module.exports = __webpack_public_path__ + "static/media/main-banner.51ecae9c.jpg";